import { render } from "./PlayerDetails.vue?vue&type=template&id=1cf5d954"
import script from "./PlayerDetails.vue?vue&type=script&lang=js"
export * from "./PlayerDetails.vue?vue&type=script&lang=js"

import "./PlayerDetails.vue?vue&type=style&index=0&id=1cf5d954&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__